import script from "./OfExportCampaignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OfExportCampaignModal.vue?vue&type=script&setup=true&lang=js"

import "./OfExportCampaignModal.vue?vue&type=style&index=0&id=492b3972&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492b3972"]])

export default __exports__